import React, { Component, PureComponent } from "react";
import logo from "./logo.svg";
import "./App.css";
import TagsList from "./TagsList";
import { Button, Input, Tooltip } from "reactstrap";
import EventTypesLegends from "./EventTypesLegends";
import EventTypesComboBox from "./EventTypesComboBox";
import TagDialog from './TagDialog'
import LoadingSpinner from './LoadingSpinner'
import { connect } from 'react-redux'
import {filterByTagIds, showStory, sortByEventTypeId, loadDataAction, selectEventTypeIds} from './TimelineReducer';

const DefaultEventTypeColour = "#2075FE";

class Timeline extends Component {
  constructor(props) {
    super(props);

    this.filterByTag = this.filterByTag.bind(this);
    this.filterByQuery = this.filterByQuery.bind(this);
    this.getYearsRange = this.getYearsRange.bind(this);
    this.tagsSelectionChanged = this.tagsSelectionChanged.bind(this);
    this.getEventsByYearAndTagIndex = this.getEventsByYearAndTagId.bind(this);
    this.eventTypeSelectionChanged = this.eventTypeSelectionChanged.bind(this);
    this.getEarliestFromYearForEventTypeAndTagId = this.getEarliestFromYearForEventTypeAndTagId.bind(
      this
    );
    this.getActualTags = this.getActualTags.bind(this);
    this.isTagHasEventType = this.isTagHasEventType.bind(this);
    this.sortByEventTypeId = this.sortByEventTypeId.bind(this);
    this.selectRulesOfAlmotanabbi = this.selectRulesOfAlmotanabbi.bind(this);
    this.selectRulesLiveAndDeathOfAlmotanabbi = this.selectRulesLiveAndDeathOfAlmotanabbi.bind(
      this
    );
    this.getTooltip = this.getTooltip.bind(this);
    this.selectTag = this.selectTag.bind(this);
    this.showTag = this.showTag.bind(this);
    this.tagDialogClosed = this.tagDialogClosed.bind(this);
    this.renderData = this.renderData.bind(this);


    window.registerSelectTagHook(this);


    this.state = {
      showTagDialog: null,
      actualTags: [],
      years: [],
      query: "",
      filterByTagIds: [-1, 1041],
      defaultTagIds: [-1, 1041],
      sortByEventTypeId: ""
    };

  }

  selectRulesOfAlmotanabbi() {
    const selectedTagIds = [
      108,
      748,
      863,
      864,
      868,
      888,
      897,
      918,
      931,
      942,
      1038,
      1039,
      1040,
      1046,
      1047,
      1056,
      1063,
      29,
      1055
    ];

    this.props.dispatch(showStory("5",selectedTagIds));
    // this.setState({
    //   selectedEventTypeIds: [5],
    //   sortByEventTypeId: "5",
    //   filterByTagIds: selectedTagIds
    // });
  }

  


  selectRulesLiveAndDeathOfAlmotanabbi() {
    const selectedTagIds = [
      108,
      748,
      863,
      864,
      868,
      888,
      897,
      918,
      931,
      942,
      1038,
      1039,
      1040,
      1046,
      1047,
      1056,
      1063,
      29,
      1055
    ];

    this.props.dispatch(showStory("2",selectedTagIds));

  }
  componentDidMount() {
    if(this.props.events === null || this.props.events === undefined) {
      this.props.dispatch(loadDataAction());
    }
  }


  sortByEventTypeId(eventTypeId) {
    this.props.dispatch(sortByEventTypeId(eventTypeId));
  }
  filterByTag(event) {
    var selectedTagId = event.target.value;
    this.setState({ filterByTagIds: selectedTagId });
  }

  eventTypeSelectionChanged(eventTypeId, selected) {
    eventTypeId = parseInt(eventTypeId);
    let selectedEventTypeIds = [...this.props.selectedEventTypeIds];
    if (selected) {
      selectedEventTypeIds.push(eventTypeId);
    } else {
      selectedEventTypeIds.splice(selectedEventTypeIds.indexOf(eventTypeId), 1);
    }
    this.props.dispatch(selectEventTypeIds(selectedEventTypeIds));
    
    // this.setState({ selectedEventTypeIds: selectedEventTypeIds });
  }

  filterByQuery(event) {
    var query = event.target.value;
    this.setState({ query: query });
  }

  getActualTags() {

    if(this.props.tags === undefined) {
      return [];
    }
    var selectedTagIds = this.props.filterByTagIds;
    return this.props.tags.filter(
      tag => selectedTagIds.indexOf(tag.tagId) !== -1
    );
  }

  isTagExists(tagId) {
    return this.props.tags.filter(tag => tag.tagId === tagId).length > 0;
  }
  getActualEvents() {
    let filteredEvents = this.props.events;
    var selectedTagIds = this.props.filterByTagIds;

    filteredEvents = filteredEvents.filter(
      event =>
        (event.tag === undefined && selectedTagIds.indexOf(-1) !== -1) ||
        (event.tag !== undefined &&
          selectedTagIds.indexOf(event.tag.tagId) !== -1)
    );
    filteredEvents = filteredEvents.filter(
      event =>
        (event.timelineEventType === undefined &&
          this.props.selectedEventTypeIds.indexOf(-1) !== -1) ||
        (event.timelineEventType !== undefined &&
          this.props.selectedEventTypeIds.indexOf(
            event.timelineEventType.eventTypeId
          ) !== -1)
    );

    var selectedEventTypeIds = this.props.selectedEventTypeIds;
    filteredEvents = filteredEvents.filter(event => {
      if (event.timelineEventType === undefined) {
        // Default case
        return selectedEventTypeIds.indexOf(-1) !== -1;
      }
      return (
        selectedEventTypeIds.indexOf(event.timelineEventType.eventTypeId) !== -1
      );
    });

    var query = this.state.query;
    if (query !== "") {
      filteredEvents = filteredEvents.filter(
        event =>
          event.eventTitle.includes(query) || event.description.includes(query)
      );
    }
    return filteredEvents;
  }

  getYearsRange(events) {
    let actualStartYear = 1000;
    let actualEndYear = 0;

    let filteredEvents = events;
    var selectedTagIds = this.props.filterByTagIds;

    filteredEvents = events.filter(
      event =>
        (event.tag === undefined && selectedTagIds.indexOf(-1) !== -1) ||
        (event.tag !== undefined &&
          selectedTagIds.indexOf(event.tag.tagId) !== -1)
    );
    filteredEvents = filteredEvents.filter(
      event =>
        (event.timelineEventType === undefined &&
          this.props.selectedEventTypeIds.indexOf(-1) !== -1) ||
        (event.timelineEventType !== undefined &&
          this.props.selectedEventTypeIds.indexOf(
            event.timelineEventType.eventTypeId
          ) !== -1)
    );

    for (var year = 100; year < 1500; year++) {
      for (var i = 0; i < filteredEvents.length; i++) {
        const theEvent = filteredEvents[i];

        if (theEvent.fromYear === year) {
          actualStartYear = Math.min(actualStartYear, year);
          actualEndYear = Math.max(actualEndYear, year);
        }
        if (
          theEvent.toYear !== undefined &&
          theEvent.toYear >= year &&
          theEvent.fromYear <= year
        ) {
          actualEndYear = Math.max(actualEndYear, year);
        }
      }
    }

    actualStartYear = Math.floor(actualStartYear / 10) * 10;

    actualEndYear = Math.ceil(actualEndYear / 10) * 10;

    let years = [];

    for (var i = actualStartYear; i < actualEndYear; i++) {
      years.push(i);
    }
    return years;
  }

  isTagHasEventType(actualEvents, tagId, eventTypeId) {
    let result = actualEvents.filter(
      event =>
        (event.tag === undefined && tagId === -1) ||
        (event.tag !== undefined && event.tag.tagId === tagId)
    );
    result = result.filter(
      event =>
        (event.timelineEventType === undefined && eventTypeId === -1) ||
        (event.timelineEventType !== undefined &&
          this.props.selectedEventTypeIds.indexOf(
            event.timelineEventType.eventTypeId
          ) !== -1)
    );
    return result.length > 0;
  }
  getEarliestFromYearForEventTypeAndTagId(actualEvents, eventTypeId, tagId) {
    const eventsForTag = actualEvents.filter(
      event =>
        (event.tag === undefined && tagId === -1) ||
        (event.tag !== undefined && event.tag.tagId === tagId)
    );
    const eventsByType = eventsForTag.filter(
      event =>
        event.timelineEventType !== undefined &&
        event.timelineEventType.eventTypeId === eventTypeId
    );
    // Sort by first from year.
    const result = eventsByType.sort((a, b) => b.fromYear - a.fromYear);
    if (result.length === 0) {
      return 99999;
    }
    return result[0].fromYear;
  }

  getEventsByYearAndTagId(actualEvents, year, tagId) {
    let filteredEvents = actualEvents.filter(
      event =>
        (event.tag === undefined && tagId === -1) ||
        (event.tag !== undefined && event.tag.tagId === tagId)
    );
    filteredEvents = filteredEvents.filter(
      event =>
        (event.timelineEventType === undefined &&
          this.props.selectedEventTypeIds.indexOf(-1) !== -1) ||
        (event.timelineEventType !== undefined &&
          this.props.selectedEventTypeIds.indexOf(
            event.timelineEventType.eventTypeId
          ) !== -1)
    );

    let result = [];
    for (var i = 0; i < filteredEvents.length; i++) {
      const theEvent = filteredEvents[i];
      if (
        theEvent.fromYear === year ||
        (year >= theEvent.fromYear &&
          theEvent.toYear !== undefined &&
          year <= theEvent.toYear)
      ) {
        let tooltip =
          (theEvent.tag === undefined ? "حدث عام" : theEvent.tag.name) +
          " (" +
          theEvent.fromYear +
          (theEvent.toYear !== undefined ? "-" + theEvent.toYear : "") +
          ")";
        tooltip +=
          "\r\n " + theEvent.eventTitle + " \r\n" + theEvent.description;
        var colour =
          theEvent.timelineEventType === undefined
            ? DefaultEventTypeColour
            : "#" + theEvent.timelineEventType.colour;
        result.push({
          eventId: theEvent.eventId,
          eventTitle: theEvent.eventTitle,
          tooltip: tooltip,
          duration: theEvent.duration,
          colour: colour,
          relatedTags: theEvent.relatedTags
        });
      }
    }
    // Sort by the more duration event first (to show it properly in the UI)
    result = result.sort((a, b) => b.duration - a.duration);
    return result;
  }

  // Hook from the index.html to select tag.
  selectTag(tagId) {
    // this.setState({ filterByTagIds: [tagId, ...this.props.filterByTagIds] });
    this.props.dispatch(filterByTagIds([tagId, ...this.props.filterByTagIds]));

  }

  showTag(tagId) {
    this.setState({showTagDialog:tagId})
  }

  tagDialogClosed() {
    this.setState({showTagDialog:null});
  }
  
  tagsSelectionChanged(tagIds) {
    this.props.dispatch(filterByTagIds(tagIds));
    // this.setState({ filterByTagIds: tagIds });
  }

  getTooltip(tooltip, relatedTags) {
    const tagPattern = /<tag\s+id=\"([0-9]{1,4})\"\s*>([^<]{1,})<\/tag>/g;
    var result = tooltip.replace(
      tagPattern,
      " <a class='commentTag' onclick=\"selectTag($1)\">$2</a> "
    );

    return result;
  }

  mouseEnter(e, content) {
    let {left, top} = e.target.getBoundingClientRect();
    window.showTooltip(content, left, top + 5);

  }

  render() {
    if(this.props.loading) {
      return <LoadingSpinner visible={true}/>;
    }

    return this.renderData();
  }

  renderData() {
    const actualEvents = this.getActualEvents();
    const yearRange = this.getYearsRange(actualEvents);
    let actualTags = this.getActualTags();
    actualTags = actualTags.filter(tag =>
      this.isTagHasEventType(actualEvents, tag.tagId, 5)
    );

    if (this.props.sortByEventTypeId !== "") {
      const sortByEventTypeId = parseInt(this.props.sortByEventTypeId);
      // Sort by eventTypeId
      actualTags = actualTags.sort((a, b) => {
        const a1 = this.getEarliestFromYearForEventTypeAndTagId(
          actualEvents,
          sortByEventTypeId,
          a.tagId
        );
        const b1 = this.getEarliestFromYearForEventTypeAndTagId(
          actualEvents,
          sortByEventTypeId,
          b.tagId
        );
        return a1 - b1;
      });
    }
    return (
      <div>
        <div className="input-group mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="بحث"
            onChange={this.filterByQuery}
          />
        </div>
        <table>
          <tbody>
            <tr>
              <td>
                <EventTypesComboBox
                  value={this.props.sortByEventTypeId}
                  eventTypes={this.props.eventTypes}
                  onChange={this.sortByEventTypeId}
                />
              </td>
              <td>
                <Button
                  size="sm"
                  style={{ backgroundColor: "#936EAC" }}
                  onClick={this.selectRulesOfAlmotanabbi}
                >
                  فترة حكم المماليك
                </Button>
              </td>
              <td>
                <Button
                  size="sm"
                  style={{ backgroundColor: "#FF753B" }}
                  onClick={this.selectRulesLiveAndDeathOfAlmotanabbi}
                >
                  حياة وموت المماليك
                </Button>
              </td>
            </tr>
          </tbody>
        </table>

        <table>
          <tbody>
            <tr>
              <td valign="top">
                <TagsList
                  filterByTagIds={this.props.filterByTagIds}
                  tags={this.props.tags}
                  tagsSelectionChanged={this.tagsSelectionChanged}
                  defaultTagIds={this.state.defaultTagIds}
                />
              </td>
              <td valign="top">
                <table border="1">
                  <tbody>
                    <tr>
                      <td />
                      <td>
                        <Years years={yearRange} />
                      </td>
                    </tr>
                    {actualTags.map(tag => (
                      <tr key={tag.tagId}>
                        <td
                          style={{ whiteSpace: "nowrap", textAlign: "center" }}
                        >
                          {tag.name}
                        </td>
                        <td>
                          <table cellSpacing="0" cellPadding="0">
                            <tbody>
                              <tr key={tag.tagId}>
                                {yearRange.map((year, index) => (
                                  <td
                                    key={year}
                                    className={index % 2 == 0 ? "dark" : ""}
                                    style={{
                                      minWidth: "8px",
                                      verticalAlign: "top"
                                    }}
                                  >
                                    {this.getEventsByYearAndTagId(
                                      actualEvents,
                                      year,
                                      tag.tagId
                                    ).map((theEvent, index) => (
                                      <div
                                        key={theEvent.timelineEventId}
                                        style={{
                                          marginTop: "1px",
                                          width: "7px",
                                          height: "20px",
                                          backgroundColor: theEvent.colour
                                        }}
                                        onMouseLeave={() =>
                                          window.hideTooltip(false)
                                        }
                                        onMouseEnter={e =>
                                          this.mouseEnter(
                                            e,
                                            this.getTooltip(
                                              theEvent.tooltip,
                                              theEvent.relatedTags
                                            )
                                          )
                                        }
                                      />
                                    ))}
                                  </td>
                                ))}
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
        <EventTypesLegends
          selectionChanged={this.eventTypeSelectionChanged}
          eventTypes={this.props.eventTypes}
          selectedEventTypeIds={this.props.selectedEventTypeIds}
        />
        {this.state.showTagDialog && <TagDialog tagId={this.state.showTagDialog} dialogClosed={this.tagDialogClosed}/>}
      </div>
    );
  }
}

export class Years extends React.Component {
  constructor(props) {
    super();
    this.yearsByDecade = this.yearsByDecade.bind(this);
  }

  yearsByDecade(years) {
    var results = [];
    const startYear = years[0];
    const endYear = years[years.length - 1];
    for (var i = startYear; i < endYear; i += 10) {
      results.push(i);
    }
    return results;
  }

  render() {
    return <div>{this.props.loading && <table cellSpacing="0">
        <tbody>
          <tr>
            {this.yearsByDecade(this.props.years).map((year, index) => (
              <td
                key={year}
                className={"year-demarcations"}
                style={{ width: "80px" }}
              >
                {year}
              </td>
            ))}
          </tr>
        </tbody>
      </table>}
      </div>
  }
}

function mapStateToProps(state) {
  return {...state.timeline};
}

export default connect(mapStateToProps)(Timeline);


// WEBPACK FOOTER //
// ./src/Timeline.js